const DocMenuConfig = [
  {
    heading: "Pentadbiran Sistem",
    route: "/laporan",
    pages: [
      {
        heading: "Dashboard",
        route: "/pentadbiran/dashboard",
        name: "pentadbiran-dashboard",
        svgIcon: "/media/icons/duotune/general/gen022.svg",
        fontIcon: "bi-archive",
        ctrl: "sistem_dashboard",
      },
      {
        sectionTitle: "Pentadbiran Pengguna",
        route: "/pages",
        svgIcon: "/media/icons/duotune/general/gen049.svg",
        fontIcon: "bi-archive",
        ctrl: "sistem_pentadbiran_pengguna",
        sub: [
          {
            heading: "Senarai Pengguna",
            route: "/senarai/pengguna",
            name: "senarai-pengguna",
            ctrl: "sistem_senarai_pengguna",
          },
          {
            heading: "Pengesahan Pengguna",
            route: "/pengesahan/pengguna",
            name: "pengesahan-pengguna",
            ctrl: "sistem_pengesahan_pengguna",
          },
          // {
          //   heading: "Peranan",
          //   route: "/userrole",
          //   name: "peranan",
          //   ctrl: "sistem_peranan",
          // },
          {
            heading: "Pemetaan PSM",
            route: "/psm/pemetaan",
            name: "psm-pemetaan",
            ctrl: "psm_pemetaan",
          },
        ],
      },
      {
        heading: "Audit Trail",
        route: "/audit/pengguna",
        name: "audit-pengguna",
        svgIcon: "/media/icons/duotune/layouts/lay002.svg",
        fontIcon: "bi-archive",
        ctrl: "sistem_audit_trail",
      },
      {
        heading: "Pengumuman",
        route: "/pentadbiran/pengumuman",
        name: "pengumuman",
        svgIcon: "/media/icons/duotune/communication/com004.svg",
        fontIcon: "bi-archive",
        ctrl: "sistem_hebahan",
      },
      {
        heading: "Soalan Lazim",
        route: "/pentadbiran/soalan-lazim",
        name: "pentadbiran-soalan-lazim",
        svgIcon: "/media/icons/duotune/general/gen046.svg",
        fontIcon: "bi-archive",
        ctrl: "sistem_soalan_lazim",
      },
      // {
      //   heading: "Pengurusan Sistem",
      //   route: "/pentadbiran/aplikasi-combo",
      //   name: "aplikasi-combo",
      //   svgIcon: "/media/icons/duotune/coding/cod003.svg",
      //   fontIcon: "bi-archive",
      // },
      {
        sectionTitle: "Pengurusan Sistem",
        route: "/pentadbiran/aplikasi-combo",
        svgIcon: "/media/icons/duotune/coding/cod003.svg",
        fontIcon: "bi-archive",
        ctrl: "sistem_pengurusan",
        sub: [
          {
            heading: "Senarai Parameter",
            route: "/pentadbiran/aplikasi-combo",
            name: "aplikasi-combo",
            ctrl: "sistem_senarai_parameter",
          },
          {
            heading: "Tetapan Templat",
            route: "/pentadbiran/templat",
            name: "pentadbiran-templat",
            ctrl: "sistem_tetapan_templat",
          },
          {
            heading: "Templat Borang",
            route: "/pentadbiran/tetapan-borang",
            name: "pentadbiran-tetapan-borang",
            ctrl: "sistem_tetapan_borang",
          },
        ],
      },
      {
        heading: "Manual Pentadbir",
        route: "/pentadbiran/manual/pentadbir",
        name: "pentadbiran-manual-pentadbir",
        svgIcon: "/media/icons/duotune/files/fil009.svg",
        fontIcon: "bi-archive",
        ctrl: "sistem_manual",
      },

      // {
      //   heading: "Tetapan Templat Notifikasi",
      //   route: "/pentadbiran/templat",
      //   name: "pentadbiran-templat",
      //   svgIcon: "/media/icons/duotune/coding/cod003.svg",
      //   fontIcon: "bi-archive",
      // },
      // {
      //   heading: "Tetapan Borang",
      //   route: "/pentadbiran/tetapan-borang",
      //   name: "pentadbiran-tetapan-borang",
      //   svgIcon: "/media/icons/duotune/coding/cod003.svg",
      //   fontIcon: "bi-archive",
      // },
      // {
      //   heading: "Paramater",
      //   route: "/pages",
      // },
      //
      // {
      //   heading: "Log dan Analisis",
      //   route: "/pentadbiran/logs",
      //   svgIcon: "/media/icons/duotune/general/gen037.svg",
      //   fontIcon: "bi-archive",
      // },
    ],
  },
];

export default DocMenuConfig;
